import React from 'react';
import SwitchViewMode from '../../common/SwitchViewMode';
import { useTranslation } from 'react-i18next';
import { RootState, useDispatch, useSelector } from '../../../redux/store';
import { setSelectedViewMode } from '../../../redux/slices/condition';
import { CONDITION_VIEW_MODES } from '../../../constants';
import type { ConditionViewMode } from '../../../types/condition';
import type { ViewModeButton } from '../../../types/common';

const ChangeViewMode = (): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { selectedViewMode } = useSelector((state: RootState) => state.condition);
  const modes: ViewModeButton<ConditionViewMode>[] = [
    {
      id: CONDITION_VIEW_MODES.APPROVED,
      active: selectedViewMode === CONDITION_VIEW_MODES.APPROVED,
      label: t('condition.approved'),
    },
    {
      id: CONDITION_VIEW_MODES.EDITING,
      active: selectedViewMode === CONDITION_VIEW_MODES.EDITING,
      label: t('condition.edit'),
    },
  ];

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // ボタンをクリックして承認済みビューと編集中ビューを切り替えたとき
  const handleClick = (event: React.MouseEvent<{ id: ConditionViewMode }>) => {
    // console.log(event.currentTarget.id);
    dispatch(setSelectedViewMode(event.currentTarget.id));
  };

  // VIEW
  // ================================================================================

  return <SwitchViewMode modes={modes} onSwitch={handleClick} />;
};

export default ChangeViewMode;
